import { render, staticRenderFns } from "./MyZs6.vue?vue&type=template&id=bdb167da&scoped=true&"
import script from "./MyZs6.vue?vue&type=script&lang=js&"
export * from "./MyZs6.vue?vue&type=script&lang=js&"
import style0 from "./MyZs6.vue?vue&type=style&index=0&id=bdb167da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb167da",
  null
  
)

export default component.exports